/*
 * Summr: fills in the free-shipping progress bar in the cart drawer.
 * Converts the threshold to the shopper's currency and keeps the bar in sync when the cart changes.
 */
(function () {
  if (customElements.get('summr-ship-progress')) return;

  class SummrShipProgress extends HTMLElement {
    connectedCallback() {
      this.update();
      this.observer = new MutationObserver(() => this.update());
      this.watch();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    watch() {
      if (!this.observer) return;
      this.observer.observe(this, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-subtotal', 'data-threshold']
      });
    }

    update() {
      if (this.observer) this.observer.disconnect();

      var shopify = window.Shopify || {};
      var cur = shopify.currency || {};
      var rate = parseFloat(cur.rate) || 1;
      var code = cur.active || 'USD';
      var threshold = (parseFloat(this.dataset.threshold) || 0) * rate;
      var subtotal = parseFloat(this.dataset.subtotal) || 0;
      var remaining = Math.max(0, threshold - subtotal);
      var pct = threshold > 0 ? Math.min(100, (subtotal / threshold) * 100) : 0;

      var amount;
      try {
        amount = new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: code,
          maximumFractionDigits: 0
        }).format(Math.ceil(remaining / 100));
      } catch (e) {
        amount = Math.ceil(remaining / 100) + ' ' + code;
      }

      var text = this.querySelector('.summr-ship__text');
      var fill = this.querySelector('.summr-ship__fill');
      if (text) {
        var next = remaining <= 0 ? this.dataset.done : (this.dataset.away || '').replace('[amount]', amount);
        if (text.textContent !== next) text.textContent = next;
      }
      if (fill) fill.style.width = pct + '%';

      this.watch();
    }
  }

  customElements.define('summr-ship-progress', SummrShipProgress);
})();
